import { useState, type FormEvent } from 'react';
import { FalhaDaApi } from '../../api/cliente';
import { Botao } from '../../componentes/base';
import { useSessaoPortal } from '../SessaoPortal';

/**
 * Entrada da clínica.
 *
 * Um campo só. O token já veio no link e não se digita — pedi-lo aqui obrigaria a
 * recepção a copiar da barra de endereço uma sequência de sessenta caracteres, e
 * qualquer erro nela devolveria "link inválido" sem dizer o porquê.
 */
export function PaginaEntrarNoPortal({ token }: { token: string }) {
  const { entrar } = useSessaoPortal();
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function submeter(evento: FormEvent) {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(token, senha);
    } catch (falha) {
      setErro(
        falha instanceof FalhaDaApi
          ? falha.message
          : 'Não foi possível conectar ao sistema. Verifique sua internet.',
      );
      setEnviando(false);
    }
    // Em caso de sucesso não se desliga o "enviando": a tela é substituída pelo
    // portal, e reabilitar o botão antes disso deixa um piscar de "Entrar" no fim.
  }

  return (
    <main className="flex min-h-dvh items-center justify-center bg-tinta-950 px-6 py-12">
      <div className="w-full max-w-[26rem]">
        <img
          src="/marca/marca-empilhada.png"
          alt="Bianca Ávila Advocacia"
          className="mx-auto mb-10 w-52"
          width={800}
          height={565}
        />

        <form
          onSubmit={(e) => void submeter(e)}
          className="rounded-lg border border-tinta-800 bg-tinta-900 p-7"
        >
          <h1 className="text-xl text-papel-100">Portal da clínica</h1>
          <p className="mt-1 mb-6 text-sm text-tinta-500">
            Acompanhe seus clientes e envie os documentos
          </p>

          <label className="mb-6 block">
            <span className="mb-1.5 block text-xs font-medium uppercase tracking-[0.1em] text-papel-500">
              Senha do portal
            </span>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              autoFocus
              required
              className="w-full rounded-md border border-tinta-700 bg-tinta-950 px-3 py-2.5 text-papel-100 placeholder:text-tinta-600 focus:border-ouro-700 focus:outline-none"
              placeholder="••••••••"
            />
          </label>

          {erro && (
            <p
              role="alert"
              className="mb-5 rounded-md border-l-[3px] px-3 py-2.5 text-sm"
              style={{
                borderColor: 'var(--color-vencido)',
                background: 'rgb(163 44 60 / 0.12)',
                color: '#f0a8b2',
              }}
            >
              {erro}
            </p>
          )}

          <Botao
            submeter
            desabilitado={enviando}
            className="w-full bg-ouro-700 py-2.5 text-tinta-950 hover:bg-ouro-600"
          >
            {enviando ? 'Entrando…' : 'Entrar'}
          </Botao>
        </form>

        <p className="mt-6 text-center text-xs text-tinta-600">
          Este link é exclusivo da sua clínica. Você vê apenas os seus clientes.
        </p>
      </div>
    </main>
  );
}
